import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';

import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from "../pages/login/login";
import { DataServiceProvider } from "../providers/data-service/data-service";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = LoginPage;

  constructor(
    public platform: Platform, 
    public statusBar: StatusBar, 
    public splashScreen: SplashScreen,
    public storage: Storage,
    private dataService: DataServiceProvider
  ) {

    // Check if the user has already seen the tutorial
    this.storage.get('hasLoggedIn')
      .then((hasLoggedIn) => {
        if (hasLoggedIn) {
          this.rootPage = TabsPage;
        } else {
          this.rootPage = LoginPage;
        }
        this.platformReady()
      });

    this.dataService.auth.onAuthStateChanged((user:any) => {
      if (user) {
        this.rootPage = TabsPage
        this.storage.set("hasLoggedIn", true);
        this.storage.set('username', user.email);
        this.storage.set('userId', user.uid);
      }else{
        this.rootPage = LoginPage
        this.storage.remove("hasLoggedIn");
        this.storage.remove('username');
        this.storage.remove('userId');
      }
    })
  }

  platformReady() {
  // Call any initial plugins when ready
  this.platform.ready().then(() => {
    this.statusBar.styleDefault();
    this.splashScreen.hide();
  });

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts